import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import PropTypes from "prop-types";
import { getAuthToken } from "utils/authToken";

export default function ProtectedRoute({ children, roles }) {
  const token = getAuthToken();

  // No token → redirect to login
  if (!token) return <Navigate to="/authentication/sign-in" replace />;

  try {
    const decoded = jwtDecode(token);

    // Token expired → redirect
    if (decoded.exp * 1000 < Date.now()) {
      return <Navigate to="/authentication/sign-in" replace />;
    }

    // Role-based access (optional)
    if (roles && roles.length > 0 && !roles.includes(decoded.role)) {
      return <Navigate to="/dashboard" replace />;
    }

    return children;
  } catch (err) {
    // Invalid token → redirect
    console.error("Invalid token:", err.message);
    return <Navigate to="/authentication/sign-in" replace />;
  }
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
};
